export const validation = {
	badge: {
		validated: "Validado",
		pending: "Pendiente de validación",
		preExisting: "Preexistente",
	},
	filter: {
		label: "Estado",
		all: "Todos",
		pending: "Pendiente de validación",
		validated: "Validados",
	},
	banner: {
		title: "¡Tienes datos fiscales para validar!",
		message: "Confirma los datos para poder utilizar estos perfiles fiscales.",
	},
	card: {
		confirmAction: "Confirmar datos",
		validateAction: "Validar datos",
		viewDetails: "Ver detalles",
	},
	drawerNotice: {
		pendingValidation: "Valida los datos para usar este perfil fiscal",
		pendingValidationGroup: "Valida los datos para usar este grupo fiscal",
	},
	modalConfirm: {
		title: "Confirmar datos fiscales",
		message:
			"¿Seguro que deseas validar los datos de este perfil fiscal? Al confirmar quedará disponible para ser utilizado en el sistema.",
		confirm: "Confirmar datos",
		success: "¡Datos validados con éxito!",
	},
	modalReject: {
		title: "Rechazar datos fiscales",
		message:
			"¿Seguro que deseas rechazar estos cambios? El registro volverá al estado anterior.",
		confirm: "Confirmar rechazo",
		success: "Datos rechazados.",
		// Registro nuevo (sin versión vigente): rechazar lo elimina permanentemente.
		newRegistrationProfile: {
			title: "Rechazar perfil fiscal",
			messageBold: "¿Seguro que deseas rechazar este perfil fiscal?",
			message: "Al confirmar será eliminado permanentemente del sistema.",
			confirm: "Rechazar perfil fiscal",
		},
		newRegistrationGroup: {
			title: "Rechazar grupo fiscal",
			messageBold: "¿Seguro que deseas rechazar este grupo fiscal de producto?",
			message: "Al confirmar será eliminado permanentemente del sistema.",
			confirm: "Rechazar grupo fiscal",
		},
	},
	infoBlock: {
		title: "Validación de datos fiscales",
		validatedAt: "Fecha/hora de la validación",
		validatedBy: "Validado por",
		newBadge: "Nuevo",
	},
	drawerFooter: {
		confirmData: "Confirmar datos",
		reject: "Rechazar",
		editProfile: "Editar perfil",
		editGroup: "Editar grupo",
	},
	// Tooltips de apoyo en el listado de registros (Figma node 3066-7771).
	tooltip: {
		pendingProfile: "Valida los datos para poder utilizar este perfil fiscal",
		pendingGroup: "Valida los datos para poder utilizar este grupo fiscal de producto",
		validatedBy: "Datos fiscales validados {{date}} por",
		validated: "Datos fiscales validados {{date}}",
	},
	form: {
		saveAndValidate: "Guardar y Validar",
		saveAndValidateSuccess: "Guardado y validado con éxito.",
	},
};
